/* eslint-disable */

<template>
  <div id="app" data-app>
    <v-card class="header-card">
      <div class="header-div">
        <div class="acct-lbl" v-if="$AuthSvc.isDesktop()">
          <a @click="signin()" class="main-actions label18" v-if="!isLoggedIn">
            Login
          </a>

          <div v-if="$AuthSvc.isLogin() && $AuthSvc.isDesktop()">
            <a @click="profile()" class="name-lbl"
               title="Update My Profile">
              Hi {{ $AuthSvc.getFullName() }}
            </a>
            <br>
            <a @click="$AuthSvc.logout()" class="logout-lbl" >
              Logout
            </a>
          </div>
        </div>

        <div class="mobile-name" v-if="$AuthSvc.isLogin() && $AuthSvc.isMobile()">
              <span class="logout-lbl">
                Hi {{ $AuthSvc.getFullName() }}
              </span>
        </div>
      </div>
    </v-card>

    <!--DESKTOP-->
    <v-card v-if="$AuthSvc.isDesktop()" class="header-bar">
      <v-list-title class="menu-btn"
             v-for="(item, index) in menu"
             :key="index"
             @click="selectMenuPath(item.path)">
        <v-btn small v-if="item.parent==='' && item.title != 'Login'" >
          <router-link to="/" class="menu-item">{{ item.title }}</router-link>
        </v-btn>

        <v-menu v-if="item.parent!==''" offset-y >
          <template v-slot:activator="{ on, attrs }">

            <v-btn small v-bind="attrs" v-on="on" class="menu-item">
              <span class="menu-item">{{item.title}}</span>
            </v-btn>
          </template>
          <v-list>
            <v-list-item class="menu-item"
                    v-for="(subItem, index) in menuMap[item.title]"
                    :key="index">
              <v-list-item class="sub-menu-item"
                                 @click="selectMenuPath(subItem.path)">
                <span class="sub-menu-item">{{ subItem.title }}</span>
              </v-list-item>
              <v-divider></v-divider>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-list-title>
    </v-card>

    <div v-if="!$AuthSvc.isDesktop()">
      <div class="mobile-menu-header">
        <v-menu offset-y close-on-content-click="true">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" class="menu-button">
              <v-icon class="menu">mdi-menu</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item
                    v-for="(item, index) in menu"
                    :key="index">

              <v-list-item v-if="item.parent===''"
                                 @click="selectMenuPath(item.path)">
                <span class="mobile-menu-item">{{ item.title }}</span>
              </v-list-item>

              <v-list-item v-if="item.parent==='parent'"
                                 @click="selectSubMenu(item)"
                                 @click.stop.prevent>
                <span class="mobile-multi-item">{{ item.title }}</span>
              </v-list-item>

              <v-list-item v-if="item.parent !=='' && item.parent!=='parent'"
                                 @click="selectMenuPath(item.path)">
                <span class="mobile-menu-subitem">{{ item.title }}</span>
              </v-list-item>

            </v-list-item>

            <v-list-item v-if="!isLoggedIn">
              <v-list-item-title @click="signin()">
                <span class="mobile-menu-item">Login</span>
              </v-list-item-title>
            </v-list-item>

            <v-list-item v-if="isLoggedIn">
              <v-list-item-title @click="profile()">
                <span class="mobile-menu-item">User Profile</span>
              </v-list-item-title>
            </v-list-item>

            <v-list-item v-if="isLoggedIn">
              <v-list-item-title @click="logout()">
                <span class="mobile-menu-item">Logout</span>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>

    <router-view />

    <div class="footer-bar">
      <v-bottom-navigation>
        <v-btn class="footer-icon" v-if="$AuthSvc.isMobile()" href="tel:6827036172">
          Call Us
          <v-icon>mdi-phone</v-icon>
        </v-btn>
        <v-btn class="footer-icon" href="https://www.facebook.com/dfwvga">
          Facebook
          <v-icon>mdi-facebook</v-icon>
        </v-btn>
        <v-btn class="footer-icon" href="mailto: dfwvga.info@dfwvga.com">
          Email
          <v-icon>mdi-email</v-icon>
        </v-btn>
      </v-bottom-navigation>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        selectedMenu: '',
        activeBtn: 1,
        menu: null,
        mobileMenu: null,
        menuMap: {},
        isLoggedIn: this.$AuthSvc.isLogin()
      }
    },
    created() {
        document.title = 'DFWVGA Golf Club';

        this.menu = [
          { title: 'Home', path: '/home', parent: '', login: 'both', role: 'user' },
//          { title: 'Feedback', path: '/feedback', parent: '', login: 'both', role: 'user' },
          { title: 'Gallery', path: '/gallery', parent: '', login: 'both', role: 'user' },
          { title: 'About', path: '/about', parent: '', login: 'both', role: 'user' },
//          { title: 'Messages', path: '/messageBoard', parent: '', login: 'both', role: 'user' },
         { title: 'Championship', path: '/championship', parent: 'parent', login: 'both', role: 'user'},
          { title: 'Tournament', path: '/tournament', parent: 'parent', login: 'both', role: 'user' },
          { title: 'Cup', path: '/cup', parent: 'parent', login: 'both', role: 'user' },
          { title: 'Players', path: '/players', parent: 'parent', login: 'both', role: 'user' },
          { title: 'Sponsors', path: '/sponsors', parent: 'parent', login: 'both', role: 'user' }
        ];

        this.mobileMenu = [
          { title: 'Home', path: '/home', parent: '', login: 'both', role: 'user' },
//          { title: 'Feedback', path: '/feedback', parent: '', login: 'both', role: 'user' },
          { title: 'Gallery', path: '/gallery', parent: '', login: 'both', role: 'user' },
          { title: 'About', path: '/about', parent: '', login: 'both', role: 'user' },
//          { title: 'Messages', path: '/messageBoard', parent: '', login: 'both', role: 'user' },
         { title: 'Championship', path: '/championship', parent: 'parent', login: 'both', role: 'user'},
          { title: 'Tournament', path: '/tournament', parent: 'parent', login: 'both', role: 'user' },
          { title: 'Cup', path: '/cup', parent: 'parent', login: 'both', role: 'user' },
          { title: 'Players', path: '/players', parent: 'parent', login: 'both', role: 'user' },
          { title: 'Sponsors', path: '/sponsors', parent: 'parent', login: 'both', role: 'user' }
        ];

        this.menuMap['Championship'] = [
              { title: 'Championship', path: '/championship', parent: 'Championship', login: 'both', role: 'user' },
              { title: 'Standing', path: '/championship-standing', parent: 'Championship', login: 'both', role: 'user' },
              { title: 'Match Play', path: '/championship-match-play', parent: 'Championship', login: 'both', role: 'user' }
        ];

        this.menuMap['Tournament'] = [
              { title: 'Schedule', path: '/schedule', parent: 'Tournament', login: 'both', role: 'user' },
             { title: 'Fun Tournaments', path: '/fun-schedule', parent: 'FunTournament', login: 'both', role: 'user' },
              { title: 'Register', path: '/registration', parent: 'Tournament', login: 'both', role: 'user' },
              { title: 'Registration List', path: '/list-registration', parent: 'Tournament', login: 'both', role: 'user' },
              { title: 'Grouping', path: '/grouping', parent: 'Tournament', login: 'both', role: 'user' },
//              { title: 'Match Play', path: '/match-play-results', parent: 'Tournament', login: 'both', role: 'user' },
              { title: 'Score Card', path: '/scoring', parent: 'Tournament', login: 'both', role: 'user' },
              { title: 'Results', path: '/results', parent: 'Tournament', login: 'both', role: 'user' },
              { title: 'Tournament Rules', path: '/tournament-rules', parent: 'Tournament', login: 'both', role: 'user' },
//              { title: 'Club Championship Rules', path: '/tournament-ccrules', parent: 'Tournament', login: 'both', role: 'user' },
              { title: 'Inclement Weather', path: '/inclement-weather', parent: 'Tournament', login: 'both', role: 'user' }
        ];

        this.menuMap['Cup'] = [
              { title: 'Leaders', path: '/cup-leader', parent: 'Texas Cup', login: 'both', role: 'user' },
              { title: 'TX Cup Agreement', path: '/tx-cup-agreement', parent: 'Texas Cup', login: 'both', role: 'user' },
              { title: 'TX Cup Qualifications', path: '/tx-cup-qualify', parent: 'Texas Cup', login: 'both', role: 'user' },
              { title: 'Red River Cup Agreement', path: '/okaga-cup-qualify', parent: 'Texas Cup', login: 'both', role: 'user' },
              { title: 'Lao Cup Agreement', path: '/lao-cup-qualify', parent: 'Texas Cup', login: 'both', role: 'user' },
//              { title: 'Rules & Agreement', path: '/cup-agreement', parent: 'Texas Cup', login: 'both', role: 'user' },
//              { title: 'CH Cup Rules', path: '/challengecup-rules', parent: 'CH Cup', login: 'both', role: 'user' },
//              { title: 'CH Cup Qualify Rules', path: '/challengecup-qualify', parent: 'CH Cup', login: 'both', role: 'user' },
//              { title: 'Agreement', path: '/challengecup-agreement', parent: 'CH Cup', login: false, 'both': 'user' }
        ];

        this.menuMap['Players'] = [
              { title: 'Players', path: '/players', parent: 'Players', login: 'both', role: 'user' },
              { title: 'Membership', path: '/membership', parent: 'Players', login: 'both', role: 'user' },
              { title: 'Handicap Index', path: '/index-calculation', parent: 'Players', login: 'both', role: 'user' },
              { title: 'Terms of Agreement', path: '/terms-agreement', parent: 'Players', login: 'both', role: 'user' }
        ];

        this.menuMap['Admin'] = [
              { title: 'Responsibilities', path: '/board-responsibility', parent: 'Admin', login: 'both', role: 'admin' },
              { title: 'Config', path: '/config-admin', parent: 'Admin', login: 'both', role: 'admin' },
              { title: 'File Manager', path: '/pic-admin', parent: 'Admin', login: 'both', role: 'admin' },
              { title: 'Home', path: '/home-admin', parent: 'Admin', login: 'both', role: 'admin' },
              { title: 'Course', path: '/course-admin', parent: 'Admin', login: 'both', role: 'admin' },
              { title: 'Player', path: '/player-admin', parent: 'Admin', login: 'both', role: 'admin' },
              { title: 'Approvals', path: '/approval-admin', parent: 'Admin', login: 'both', role: 'admin' },
              { title: 'Grouping', path: '/grouping-admin', parent: 'Admin', login: 'both', role: 'admin' },
              { title: 'Schedule', path: '/schedule-admin', parent: 'Admin', login: 'both', role: 'admin' },
              { title: 'Sponsor', path: '/sponsor-admin', parent: 'Admin', login: 'both', role: 'admin' },
              { title: 'Register', path: '/register-admin', parent: 'Admin', login: 'both', role: 'admin' },
              { title: 'Handicap', path: '/handicap-admin', parent: 'Admin', login: 'both', role: 'admin' },
              { title: 'Statistics', path: '/stats', parent: 'Admin', login: 'both', role: 'admin' }
        ];

        this.menuMap['Sponsors'] = [
              { title: 'Sponsors', path: '/sponsor-ads', parent: 'Sponsors', login: 'both', role: 'user' },
              { title: 'Sponsor Packages', path: '/sponsors-packages', parent: 'Sponsors', login: 'both', role: 'user' }
        ];
    },
    mounted: function() {
       this.$AuthSvc.authenticated(this.successAuth);
    },
    methods: {
      successAuth() {
        if (this.$AuthSvc.getUserInfo() != null && this.$AuthSvc.getUserInfo().role === 'ADMIN') {
          this.menu.push( { title: 'Admin', path: '/admin', parent: 'parent', login: 'both', role: 'user' } );
          this.mobileMenu.push( { title: 'Admin', path: '/admin', parent: 'parent', login: 'both', role: 'user' } );
          // this.menu.push( { title: 'Championship', path: '/championship', parent: 'parent', login: 'both', role: 'user' } );
          // this.mobileMenu.push( { title: 'Championship', path: '/championship', parent: 'parent', login: 'both', role: 'user' } );
        }
      },
      setLogin(status) {
        this.isLoggedIn = status;
      },
      signin: function() {
        window.localStorage.setItem('__LastUrl__', '/home');
        window.location.href = '/signin';
      },
      logout: function() {
        this.$AuthSvc.logout();
      },
      profile() {
        window.location.href = '/profile';
      },
      checkLogin: function(status) {
        if (status === 'both') {
          return true;
        } else if (status === 'yes') {
          return this.$AuthSvc.isLogin() === true;
        } else if (status === 'no') {
          return this.$AuthSvc.isLogin() === false;
        }
      },
      selectMenuPath: function(path) {
//        this.$router.push(path);
        window.location.href = path;
      },
      selectSubMenu: function(item) {
        if ( item.parent !== '') {
          if (this.selectedMenu === '' || this.selectedMenu !== item.title) {
            this.selectedMenu = item.title;

            this.menu = [];
            for(var i=0; i < this.mobileMenu.length; i++) {
              this.menu.push(this.mobileMenu[i]);

              if (this.mobileMenu[i].title === this.selectedMenu) {
                for(var j=0; j < this.menuMap[this.selectedMenu].length; j++) {
                  this.menu.push(this.menuMap[this.selectedMenu][j]);
                }
              }
            }
          }
          else {
            this.selectedMenu = '';
            this.menu = this.mobileMenu;
          }
        }
        else {
          this.selectedMenu = '';
          this.menu = this.mobileMenu;
        }
      }
    }
  }
</script>

<style scoped>

  .header-div {
    display: inline-block;
    width: 100%;
    height: 100px !important;
    background-image: url("./assets/img/dfwvga-header-11.png");
    background-size: cover;
    background-color: #0f0e0f;
  }

  .menu-div {
    display: inline-block;
    width: 100%;
    height: 40px !important;
    background-color: #0f0e0f;
    padding: 7px;
    margin-top: -7px;
  }

  .header-bar {
    width: 100% !important;
    height: 0;
  }

  .header-card {
    padding: 0;
    height: 100px;
    background-color: #0f0e0f;
  }

  .v-image {
    height: 100%;
    width: 100%;
  }

  .mobile-menu-header {
    display: inline-block;
    float: right;
  }

  .menu-button {
    top: -35px;
    margin-right: 15px;
    height: 30px !important;
    width: 50px !important;
  }

  .menu-btn {
    margin: 5px 5px;
  }

  .v-btn {
    background-color: #e6f2ea !important;
  }

  .v-btn__content {
    margin: 0;
    padding: 0px 0px;
  }

  .v-list-item {
    min-height: 20px !important;
    padding: 7px 10px;
  }

  .v-list {
    padding: 3px 10px !important;
  }

  .v-toolbar__content {
    background-color: #d5ebdd;
    height: 36px !important;
  }

  .footer-bar {
    padding-top: 5px;
  }

  .footer-bar > div {
    background-color: #d5ebdd;
  }

  .footer-bar button {
    margin: 2px 10px;
    background-color: none !important;
  }

  .v-menu__content {
    width: 280px;
    left: 142px;
  }

  .v-bottom-navigation {
    padding: 7px !important;
  }

  .footer-icon {
    text-align: left;
    background-color: #d5ebdd !important;
  }

  .footer-icon:hover {
    background-color: darkseagreen !important;
  }

  .sub-menu-item {
    font-size: 16px;
    font-weight: bold !important;
  }

  .mobile-menu-item {
    font-size: 24px;
    font-weight: 900;
    color: darkgreen;
  }

  .mobile-multi-item {
    font-size: 24px;
    font-weight: 900;
    color: darkblue;
  }

  .mobile-menu-subitem {
    margin-left: 15px;
    font-size: 20px;
    font-weight: 900;
    color: green;
  }

  .main-actions {
    color: #f0f1f2;
    margin-top: 5px;
    font-size: 16px;
    font-weight: bold;
    text-decoration: none;
  }


  .acct-lbl {
    float: right;
    margin-top: 15px;
    margin-right: 15px;
    color: white;
  }

  .name-lbl {
    font-size: 18px;
    font-weight: bold;
    color: gold;
  }

  .mobile-name {
    position: relative;
    top: 70px;
    left: 10px;
  }

  .logout-lbl {
    font-size: 14px;
    font-weight: bold;
    color: gold;
  }

  img {
    width: 100%;
  }

  @media (min-width: 768px) {
    .menu-item {
      font-size: 12px !important;
    }

    .v-app-bar button {
      background-color: darkgreen !important;
    }

    .header-card {
      height: 260px !important;
    }

    .header-div {
      height: 260px !important;
    }

    .menu-item:hover {
      color: cyan;
    }

    .sub-menu-item:hover {
      color: blue;
    }

    .header-div a:hover {
      cursor: pointer;
      color: gold !important;
    }

    .name-lbl {
      color: white;
    }

    .logout-lbl {
      color: white;
    }
  }

</style>